/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAPIAction } from './api';
import { createTypesMap } from './types';

export const types = createTypesMap('usage', [
  'apps',
  'gateways',
  'nodes',
]);

function apps() {
  return createAPIAction(
    types.apps,
    {
      endpoint: '/lora/applications/count',
    })();
}

function gateways() {
  return createAPIAction(
    types.gateways,
    {
      endpoint: '/lora/gateways/count',
    })();
}

function nodes() {
  return createAPIAction(
    types.nodes,
    {
      endpoint: '/lora/nodes/count',
    })();
}

export default {
  apps,
  gateways,
  nodes,
};




// WEBPACK FOOTER //
// ./src/redux/actions/usage.js